import BaseDecorator from "./BaseDecorator";

export default class ProductVariantDecorator extends BaseDecorator {
  constructor(data) {
    super({
      // Null-by-default so the sale window controls stay controlled even
      // when the payload predates these fields (BE not deployed yet, raw
      // constructor call in a test, ...).
      default_sale_starts_at_offset_seconds: null,
      default_sale_starts_at: null,
      default_sale_ends_at_offset_seconds: null,
      default_sale_ends_at: null,
      ...data,
    });
  }

  static get pricelist_types() {
    return [
      ["pricelist_by_person", I18n.t("attributes.per_person")],
      ["pricelist_by_item", I18n.t("attributes.per_item")],
      ["pricelist_by_order", I18n.t("attributes.per_order")],
    ];
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductVariantDecorator.js